import { forwardRef, useState, useRef } from 'react';
import classNames from 'classnames';
import styles from './pop-out-player-wrapper.module.scss';
import {
  PopOutPlayerOverlay,
  PopOutPlayerOverlayProps,
} from '../pop-out-player-overlay/pop-out-player-overlay';

export const PopOutPlayerWrapper = forwardRef<
  HTMLDivElement,
  PopOutPlayerOverlayProps
>((props, ref) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isFocused, setIsFocused] = useState(false);

  const onContainerKeyDown = (evt: React.KeyboardEvent<HTMLDivElement>) => {
    switch (evt.key) {
      case 'Escape':
        if (props.onCloseClick) {
          props.onCloseClick();
        }
        break;
      case ' ':
        if (props.onOverlayClick) {
          props.onOverlayClick();
          evt.preventDefault();
        }
        break;
    }
  };

  return (
    <div
      ref={containerRef}
      className={classNames(
        styles['pop-out-player'],
        isFocused && styles['pop-out-player--show-overlay'],
      )}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onKeyDown={onContainerKeyDown}
    >
      <div className={styles['pop-out-player__video']} ref={ref} />
      <div className={styles['pop-out-player__overlay']}>
        <PopOutPlayerOverlay {...props} />
      </div>
    </div>
  );
});
